import { HttpClient } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { environment } from "../../../../environments/environment";
import { ApiErrorHandlerService } from "../../utils/api-error-handler/api-error-handler.service";

import { AssetType } from "../../../enums/assetTypes.enum";

export interface EnergyDataExportRequest {
  assetId: string;
  assetType: string;
  from: string;
  to: string;
  aggregation: "hour" | "day";
  keys: string;
}

@Injectable({
  providedIn: "root",
})
export class EnergyExportService {
  private http = inject(HttpClient);
  private apiErrorHandler = inject(ApiErrorHandlerService);

  /**
   * Fetches the energy export PDF file for the given customer and time range.
   * @param startDate The start time of the time range.
   * @param endDate The end time of the time range.
   * @param customerId The ID of the customer asset.
   * @param lang The language of the PDF file.
   * @returns An observable of the PDF file.
   */
  public getEnergyReport(from: string, to: string, assetType: AssetType, assetId: string, lang: string) {
    return this.http
      .get(
        `${environment.baseUrl}/energyExport?assetId=${assetId}&assetType=${assetType}&from=${from}&to=${to}&lang=${lang}`,
        {
          responseType: "blob",
        }
      )
      .pipe(this.apiErrorHandler.handle());
  }

  /**
   * Fetches the energy data export file for the given asset and time range.
   */
  public getEnergyDataExport(request: EnergyDataExportRequest) {
    return this.http
      .get(`${environment.baseUrl}/energyDataExport`, {
        params: {
          assetId: request.assetId,
          assetType: request.assetType,
          from: request.from,
          to: request.to,
          aggregation: request.aggregation,
          keys: request.keys,
        },
        responseType: "blob",
        observe: "response",
      })
      .pipe(this.apiErrorHandler.handle());
  }
}
